const MENU_TITLE_FIELD_NAMES = {
  TITLE: 'title',
  STYLED_TITLE: 'styledTitle',
  DESCRIPTION: 'description',
  STYLED_DESCRIPTION: 'styledDescription',
  DIET_DESCRIPTORS: 'dietDescriptors',
  ALLERGEN_DESCRIPTORS: 'allergenDescriptors',
  ADDON_DESCRIPTORS: 'addonDescriptors',
}

export default MENU_TITLE_FIELD_NAMES
